$(document).ready(function() {
    var src = '';
    var data = '';
    var mediaIndex = 0;
    var mediaLength = $('.js-media-item').length - 1;
    if ($('.b-gallery').length > 0) {
        setTimeout(function() {
            mediaLength = $('.slick-slide').length - 1;
        }, 10);
    }

    if ($(".b-full-screen__video.video-js").length > 0) {
        var firstId = $(".b-full-screen__video.video-js").attr('id');
        var player = videojs(firstId);
    }

    function defineItem(thisObject) {
        $('.b-full-screen__video').removeClass('show');
        if (thisObject.hasClass('js-media-image')) {
            $('.b-full-screen').find('img').attr('src', src);
            $('.b-full-screen__img').show();
        } else if (thisObject.hasClass('js-media-video')) {
            $('.b-full-screen__img').hide();
            $('#' + data).addClass('show');
            player = videojs(data);
            player.play();
        }
    }

    $(document).on('click', '.js-media-item', function() {
        src = $(this).find('img').attr('src');
        data = $(this).attr('data-video');
        defineItem($(this));
        $('body').addClass('is-modal-open');
        $('.js-full-screen').addClass('show');
        mediaIndex = $('.js-media-item').index(this);
        if ($(this).attr('data-download')) {
            $('.b-full-screen').addClass('download');
            $('.b-full-screen .b-news__more').attr('href', $(this).attr('data-download'));
        } else {
            $('.b-full-screen').removeClass('download');
        }
    });
    $(document).on('click', '.js-full-screen-prev', function() {
        if (mediaIndex > 0) {
            if ($(".b-full-screen__video.video-js").length > 0) {
                if (player.hasStarted_){
                    player.pause();
                }
            }
            mediaIndex--;
            src = $('.js-media-item').eq(mediaIndex).find('img').attr('src');
            data = $('.js-media-item').eq(mediaIndex).attr('data-video');
            defineItem($('.js-media-item').eq(mediaIndex));
            if ($('.js-media-item').eq(mediaIndex).attr('data-download')) {
                $('.b-full-screen').addClass('download');
                $('.b-full-screen .b-news__more').attr('href', $('.js-media-item').eq(mediaIndex).attr('data-download'));
            } else {
                $('.b-full-screen').removeClass('download');
            }
        }
    });
    $(document).on('click', '.js-full-screen-next', function() {
        if (mediaIndex < mediaLength) {
            if ($(".b-full-screen__video.video-js").length > 0) {
                if (player.hasStarted_){
                    player.pause();
                }
            }
            mediaIndex++;
            src = $('.js-media-item').eq(mediaIndex).find('img').attr('src');
            data = $('.js-media-item').eq(mediaIndex).attr('data-video');
            defineItem($('.js-media-item').eq(mediaIndex));
            if ($('.js-media-item').eq(mediaIndex).attr('data-download')) {
                $('.b-full-screen').addClass('download');
                $('.b-full-screen .b-news__more').attr('href', $('.js-media-item').eq(mediaIndex).attr('data-download'));
            } else {
                $('.b-full-screen').removeClass('download');
            }
        }
    });
    $(document).on('click', '.js-full-screen-close', function() {
        if ($(".b-full-screen__video.video-js").length > 0) {
            if (player.hasStarted_){
                player.pause();
            }
        }
        $('body').removeClass('is-modal-open');
        $('.js-full-screen').removeClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/general/full-screen.js